import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { EnvelopeFill, TelephoneFill, Clock } from "react-bootstrap-icons";
import {
  Anchor,
  Button,
  SectionTitle,
  Text,
} from "../../components/styledComponent";
import fleetCardImg from "../../assets/fleetCard.png";
import benefitOne from "../../assets/benefitOne.png";
import benefitTwo from "../../assets/benefitTwo.png";
import benefitThree from "../../assets/benefitThree.png";
import benefitFour from "../../assets/benefitFour.png";
import styles from "./style.module.scss";
import { routes } from "../../utils/routes";
import banner from "../../assets/xpressBanner.webp";
// import bannerWord from "../../assets/xpressFleetBannerWord.webp";
import fleetPdf from "../../assets/fleetpdf.pdf";

const CancoFleetCard = () => {
  const loginUrl = process.env.REACT_APP_LOGIN_URL;
  return (
    <div className={styles.fleetCardPage}>
      {/* Banner section */}
      <div className={styles.bannerSection}>
        <img src={banner} alt="Fleet card" />
        {/* <img src={bannerWord} alt="Fleet card" /> */}
        <Anchor href={loginUrl}>Login</Anchor>
      </div>

      {/* Benefits of fleet card */}
      <Container className={`sectionContainer ${styles.benefitsFleetCard}`}>
        {/* <Row className={styles.benefitsTitle}>
          <Col>
            <SectionTitle>A fleet card that works for you!</SectionTitle>
          </Col>
        </Row> */}
        <Row className={styles.benefitsContent}>
          <Col xs={12} md={12} lg={6} className={styles.benefitInfo}>
            <SectionTitle>Benefits</SectionTitle>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitOne} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>Annual Fee: $0</li>
                  <li>Tiered Volume Discounts</li>
                  {/* <li>5% Discount on Automotive Purchases</li> */}
                </ul>
              </div>
            </div>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitTwo} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>Dedicated Customer Service</li>
                  <li>Pin Protected</li>
                  <li>Spending Control</li>
                </ul>
              </div>
            </div>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitThree} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>Easy to Manage</li>
                  <li>Detailed Card Reporting</li>
                </ul>
              </div>
            </div>
            <div className={styles.benefitBlock}>
              <div>
                <img src={benefitFour} alt="benefit" />
              </div>
              <div>
                <ul>
                  <li>
                    High quality fuel purchased from same terminals as major
                    national brands
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <img src={fleetCardImg} alt="Fleet card" />
          </Col>
        </Row>
      </Container>

      {/* Apply Today */}
      <div className={styles.applyTodaySection}>
        <Container className={`sectionContainer`}>
          <Row>
            <Col xs={12} md={12} lg={6}>
              <div>
              <SectionTitle>Online Application</SectionTitle>
              <div className={styles.applySteps}>
                <div className={styles.stepInfo}>
                  {/* <h3>1</h3> */}
                  <Text>
                    Apply for your Xpress Fleet Card today and streamline your
                    fuel management. Click on the button below to begin your
                    online application.
                  </Text>
                </div>
                {/* <div className={styles.stepInfo}>
                  <h3>2</h3>
                  <Text>Send Application and Void Cheque</Text>
                </div>
                <div className={styles.stepInfo}>
                  <h3>3</h3>
                  <Text>
                    Send by email to{" "}
                    <a href="xpress@cancopetroleum.ca">
                      xpress@cancopetroleum.ca
                    </a>
                  </Text>
                </div> */}
              </div>
              </div>
              <Anchor href={routes.APPLY_CANCO_CONNECT}>
                START APPLICATION
              </Anchor>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <div>
              <SectionTitle>Printed Version</SectionTitle>
              <div className={styles.applySteps}>
                <div className={styles.stepInfo}>
                  {/* <h3>1</h3> */}
                  <Text>
                    If you wish to send in your application by Email or Mail,
                    please print off the application by clicking below.
                  </Text>
                </div>
                {/* <div className={styles.stepInfo}>
                  <h3>2</h3>
                  <Text>Send Application and Void Cheque</Text>
                </div>
                <div className={styles.stepInfo}>
                  <h3>3</h3>
                  <Text>
                    Send by email to{" "}
                    <a href="xpress@cancopetroleum.ca">
                      xpress@cancopetroleum.ca
                    </a>
                  </Text>
                </div> */}
              </div>
              </div>
              <Button onClick={() => window.open(fleetPdf, "_blank")}>
                PRINT APPLICATION
              </Button>
            </Col>
            {/* <Col xs={12} md={12} lg={6}>
              <h5>
                If you wish to send in your application by Email or Mail, please
                follow the steps below:
              </h5>
              <ul>
                <li>
                  Please{" "}
                  <button
                    onClick={() => window.open(fleetPdf, "_blank")}
                    style={{ color: "#c9a745" }}
                  >
                    click here
                  </button>{" "}
                  to download the PDF version of the application
                </li>
                <li>Include a void cheque when sending in your application</li>
                <li>
                  Mail to the Canco Petroleum Head Office located at 200 - 125,
                  Hwy 33 E, Kelowna, BC V1X 2A1
                </li>
              </ul>
              <Text style={{ marginBottom: "10px" }}>OR</Text>
              <ul>
                <li>
                  Please scan the completed application and the void cheque,
                  then attach them in an email addressed to{" "}
                  <a href="mailto:xpress@cancopetroleum.ca">
                    xpress@cancopetroleum.ca
                  </a>
                </li>
              </ul>
              <Text>
                For questions or concerns, please send us an email
                <br />
                <a href="mailto:xpress@cancopetroleum.ca">
                  xpress@cancopetroleum.ca
                </a>
              </Text>
            </Col> */}
          </Row>
        </Container>
      </div>

      <section className={styles.contactSection}>
        <Container>
          <Text $textAlign="center" $fontWeight={700} className={styles.contactIntro}>
            For questions or concerns, get in touch with the Xpress team.
          </Text>
          <div className={styles.contactDetailsBlock}>
            <a href="mailto:xpress@cancopetroleum.ca" className={styles.contactItem}>
              <EnvelopeFill className={styles.contactIcon} aria-hidden />
              <span className={`${styles.contactDetailText} ${styles.contactEmail}`}>xpress@cancopetroleum.ca</span>
            </a>
            <a href="tel:+12508648437" className={styles.contactItem}>
              <TelephoneFill className={styles.contactIcon} aria-hidden />
              <span className={styles.contactDetailText}>250-864-8437</span>
            </a>
            <div className={styles.contactItem}>
              <Clock className={styles.contactIcon} aria-hidden />
              <span className={styles.contactDetailText}>08:00am – 04:00pm PST</span>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default CancoFleetCard;
